import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { updateOptions } from '../../../../../../actions';
import { CustomPresetParamName } from '../../../../../../types';

export const useHandleParamChange = () => {
  const dispatch = useDispatch();

  return useCallback((paramName: CustomPresetParamName, newValue: unknown) => {
    if (!newValue) {
      dispatch(updateOptions({ selectedPresets: { custom: false } }));
    }
    dispatch(updateOptions({ customPreset: { params: { [paramName]: newValue } } }));
  }, [dispatch]);
};
